module.exports = __webpack_public_path__ + "img/modelOrange.76ccbd0c.jpg";